import './HelpNavMobile.scss';
import React from 'react';
import PropTypes from 'prop-types';
import { Grid, Icon } from 'semantic-ui-react';

import HelpNodeBrowser from 'components/help/nav/topicNodes/HelpNodeBrowser';
import ContactUsNode from 'components/help/nav/topicNodes/ContactUsNode';

class HelpNavMobileContainer extends React.Component {
  render() {
    return <HelpNavMobile {...this.props} />;
  }
}

class HelpNavMobile extends React.Component {
  static propTypes = {
    backHandler: PropTypes.func,
    nodeHierarchy: PropTypes.array.isRequired,
    selectedNodeId: PropTypes.string,
  };

  static contextTypes = {
    getString: PropTypes.func.isRequired,
  };

  render() {
    const { getString } = this.context;

    return (
      <div>
        <div className="aa-help-nav-mobile-back">
          <a href="#" onClick={this.props.backHandler}>
            <Icon name="chevron left" />
            { getString('AA_Back') }
          </a>
        </div>
        <div className="aa-help-nav-mobile">
          <Grid divided="vertically">
            <Grid.Row columns={1}>
              <div className="aa-help-nav-mobile__title">
                { getString('AA_Help_Navigation_Title') }
              </div>
            </Grid.Row>
            <Grid.Row columns={1}>
              <div className="aa-help-nav-mobile__hierarchy">
                <HelpNodeBrowser
                  nodeHierarchy={this.props.nodeHierarchy}
                  selectedNodeId={this.props.selectedNodeId}
                />
                <ContactUsNode title={getString('AA_Contact_Us')} />
              </div>
            </Grid.Row>
          </Grid>
        </div>
      </div>
    );
  }
}

export default HelpNavMobileContainer;
